import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
    useForm
} from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { bindDropDown, callAPI, convertToUTCISOString, dateFormat, getLocalValue, IsSmallScreen, LoacalVariables, Method, updateMainHeader } from "../../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../../Components/AutoComplete/AutoComplete";
import WSMultiAutoComplete from "../../../../Components/AutoComplete/WSMultiAutocomplete";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";
import WSDateTimeField from "../../../../Components/DateField/WSDateTimePicker";
import { HeaderList, IHeaderListActions } from "../../../../Components/Header/HeaderList";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import WSTimePicker from "../../../../Components/WSTimePicker/WSTimePicker";
import config from "../../../../Config/clientConfig.json";
import { IMeeting } from "../../../DTO/Dto";
import { breadCrumbsStore } from "../../../../Components/BreadCrumbs/BreadCrumbsListner";

export const CreateMeeting: React.FC<any> = (props) => {
    const { showMessage } = useSnackbar();
    const { id } = useParams()
    const [leadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false)
    const [activityDate, setActivityDate] = useState<any>(undefined);
    const navigate = useNavigate();
    const [isReminder, setIsReminder] = useState(false);
    const [dealsData, setDealsData] = useState<any>([])
    const [particpants, setparticpants] = useState<any>([])
    const isMobile = IsSmallScreen()
    useEffect(() => {
        updateMainHeader("Schedule Meeting");
        breadCrumbsStore.updateBreadCrumbs([
            { "Meetings": "/meeting/list" },
            { [id ? 'Edit Meeting' : "Create Meeting"]: `` },
        ]);
    });
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    //  deals/{leadId}/lead
    const source = {
        url: "auth/search",
        page: 1,
        pageSize: 10000000,
        filter: [],
        sort: [],
    };
    useEffect(() => {

        const getDeals = async () => {
            try {
                const response: any = await callAPI(`deals`, Method.GET, null, null);
                if (Array.isArray(response)) {
                    const updatedDeals = response.map((item: any) => ({
                        value: item.id,
                        label: item.dealName
                    }));


                    setDealsData(updatedDeals || []);
                }
            }

            catch (e) {

            }
        }

        getDeals();

    }, [])
    useEffect(() => {
        try {
            async function getLeads() {
                const response: any = await bindDropDown('leads', 'firstName', 'id', Method.GET, ['firstName', 'lasttName'])
                setLeadData(response)
            }
            
            getLeads()
        }
        catch (e) {
        }
    }, [])
    useEffect(() => {

        const getMeetings = async () => {
            try {
                const response: any = await callAPI(`meetings`, Method.GET, null, id);

                setValue('title', response?.title)
                setValue('startDateTime', dateFormat(response?.startDateTime, 'DD-MM-YYYY HH:mm:ss'))
                setValue('endDateTime', dateFormat(response?.endDateTime, 'DD-MM-YYYY HH:mm:ss'))
                setValue('meetingType', response?.meetingType)
                setValue('dealId', response?.dealId)
                setValue('notes', response?.notes)
                setValue('leadId', response?.leadId)
                setparticpants(response?.participantIds)
                setValue('reminderOption', response?.reminderOption)
                setValue('customReminderTime', response?.customReminderTime)
                setValue('reminderSent', response?.reminderSent)
            }

            catch (e) {

            }
        }
        if (id) {
            getMeetings();
        }
    }, [id])
    const handleActivityChange = (evt: any) => {

        if (evt.target.value !== 'custom') {
            let date = dayjs();
            const val = evt.target.value === 1 ? 0 : evt.target.value === 2 ? 1 : evt.target.value
            date = date.add(Number(val), 'days'); // Assuming value is number of days
            setActivityDate(date.toISOString()); // Converts to ISO 8601 format
        } else {

            setActivityDate(evt.target.value);
        }
    };
    const handleIsReminderSend = (evt: any) => {
        setIsReminder(evt?.target?.checked)
    }
    const transFormData = (data: any) => {

        const users: Array<any> = []
        data.map((item: any) => {
            users.push({ value: item.id, label: `${item.firstName} ${item.lastName || ""}` })
        })
        return users
    }
    const handleDataSaveAndNew = async (data: any) => {
        try {
            setLoadingSaveAndNew(true)
            const response: any = await saveData(data);
            if (response && response?.message) {

                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    reset()
                }
            } else if (response?.id) {
                reset()
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoadingSaveAndNew(false)
        }
    }
    const handleData = async (data: any) => {
        try {
            setLoading(true)
            const response: any = await saveData(data);
            if (response && response?.message) {
                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    navigate(`/meeting/list`)
                }
            } else if (response?.id) {
                showMessage('Deals Created Successfully', 'success')
                navigate(`/meeting/list`)
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoading(false)
        }
    }
    const saveData = async (data: IMeeting) => {
        const startDate: any = convertToUTCISOString(data?.startDateTime.toString())
        const endDate: any = convertToUTCISOString(data?.endDateTime.toString())
        const valuesArray = data?.participantIds.map((participant: any) => participant.value);
        const request: IMeeting = {
            title: data?.title || "",
            startDateTime: startDate || "",
            endDateTime: endDate || "",
            hostUserId: getLocalValue(LoacalVariables.UserId),//data?.assignedToUserId || getLocalValue(LoacalVariables.UserId) ,
            leadId: data?.leadId || "",
            participantIds: valuesArray,
            customReminderTime: data.customReminderTime,
            notes: data?.notes || "",
            dealId: data?.dealId || "",
            meetingType: data?.meetingType || "",
            reminderOption: data?.reminderOption?.toString()

        }

        if (data?.meetingId) {
            const response: any = await callAPI("meetings", Method.PUT, request, data?.meetingId);
            return response
        } else {
            const response: any = await callAPI("meetings", Method.POST, request);
            return response
        }
    }
    const handleCancelClick = () => {
        navigate(`/meeting/list`)
    }
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', disabled: id !== undefined, text: 'Save & New', loading: loadingSaveAndNew, size: 'small', onClick: handleSubmit(handleDataSaveAndNew), buttonType: 'button', variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', loading: loading, size: 'small', onClick: handleSubmit(handleData), buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]
    return (
        <Grid >
            <HeaderList title={!id ? "Create New Meeting" : "Update Meeting"} type="card" position="relative" actions={actions} isBackButton={true} url="/meeting/list" />
            {<Card>
                <CardContent>
                    <form>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12}>
                                <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Meeting Information</Typography>
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <WSTextField
                                    label={"Title"}
                                    {...register("title")}
                                    id="title"
                                    name="title"
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <WSDateTimeField
                                    label={"Start Date"}
                                    id="startDateTime"
                                    setValue={setValue}
                                    name="startDateTime"
                                    control={control}
                                    viewClock={false}
                                    rules={{ required: true }}

                                />

                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSDateTimeField
                                    label={"End Date"}
                                    id="endDateTime"
                                    setValue={setValue}
                                    name="endDateTime"
                                    control={control}
                                    viewClock={false}
                                    rules={{ required: true }}

                                />

                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    options={config.taskTypeSourceConfig.staticOptionData}
                                    rules={{ required: true }}
                                    {...register("meetingType")}
                                    id="meetingType"
                                    isMobile={isMobile}
                                    control={control}
                                    defaultValue={"0"}
                                    label="Meeting type"
                                    name="meetingType"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {leadData && leadData.length > 0 && <WSAutocompleteField
                                    options={leadData}
                                    rules={{ required: true }}
                                    {...register("leadId")}
                                    id="leadId"
                                    isMobile={isMobile}
                                    control={control}
                                    label="Lead"
                                    name="leadId"
                                />}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    options={dealsData}
                                    rules={{ required: true }}
                                    {...register("dealId")}
                                    id="dealId"
                                    isMobile={isMobile}
                                    control={control}
                                    label="Deal"
                                    name="dealId"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSMultiAutoComplete
                                    source={source}
                                    rules={{ required: true }}
                                    transFormData={transFormData}
                                    {...register("participantIds")}
                                    // id="participantIds"
                                    setValue={setValue}
                                    multiple={true}
                                    // isMobile={isMobile}
                                    control={control}
                                    defaultValue={particpants}
                                    label="Participants"
                                    name="participantIds"
                                />
                            </Grid>


                            <Grid item xs={12} sm={12}>
                                <WSTextAreaField
                                    label={"Notes"}
                                    {...register("notes")}
                                    id="notes"
                                    name="notes"
                                    control={control}
                                    rules={{ required: false }}
                                    rows={2}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <WSSCheckBoxField
                                    label="Reminder Send"
                                    id="reminderSent"
                                    control={control}
                                    {...register("reminderSent")}
                                    rules={{ required: false }}
                                    name="reminderSent"

                                    onChange={handleIsReminderSend}
                                />

                                <WSHiddenField control={control} name="meetingId" defaultValue={id} />
                            </Grid>

                            {isReminder && <><Grid item xs={12} sm={6}>
                                <WSTimePicker
                                    id="customReminderTime"
                                    name="customReminderTime"
                                    label={"Reminder Time"}
                                    control={control}
                                    setValue={setValue}
                                    rules={{ required: true }}
                                />
                            </Grid>
                                <Grid item xs={12} sm={6}>
                                    <WSSelectField
                                        options={config.reminderSourceConfig.staticOptionData}
                                        rules={{ required: true }}
                                        {...register("reminderOption")}
                                        id="reminderOption"
                                        isMobile={isMobile}
                                        control={control}
                                        defaultValue={0}
                                        label="Reminder"
                                        name="reminderOption"
                                    />
                                </Grid></>}

                            <Grid item xs={12} sm={12}>
                                <Divider />
                            </Grid>
                            {/* <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton className="ws-theme-crm" variant="outlined" id='meetingSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading} />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid> */}
                        </Grid >
                    </form>
                </CardContent>
            </Card>

            }
        </Grid >
    );
};

